
import FavoriteSearchResultsComp from 'applications/desktop/package-compare-app/components/search-results/search-results.favorite'
export default class FavoriteSearchResults extends FavoriteSearchResultsComp {}
